import { playInstallReferrer } from "./installHandoff";
export const detectMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  return {
    isMobile: /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase()),
    isAndroid: /android/i.test(userAgent),
    isIOS: /iphone|ipad|ipod/i.test(userAgent),
    isSmallScreen: window.innerWidth <= 768,
    userAgent: userAgent
  };
};

export const shouldShowMobileLanding = () => {
  const { isMobile, isSmallScreen } = detectMobileDevice();
  const bypassMobile = localStorage.getItem('bypassMobileLanding');

  // Never redirect on localhost — allows mobile layout testing in DevTools
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  if (isLocalhost) return false;

  // Check if we're in a WebView (Flutter app)
  const userAgent = navigator.userAgent || '';
  const isInWebView = userAgent.includes('wv') || // Android WebView
                      userAgent.includes('SikiApp') || // Custom user agent if set
                      window.flutter_inappwebview !== undefined; // Flutter InAppWebView

  return isMobile && isSmallScreen && !bypassMobile && !isInWebView;
};

// Android links carry the pending share link through the install (see installHandoff).
export const getAppStoreUrl = (platform) => {
  const referrer = platform === 'android' ? playInstallReferrer() : '';
  const urls = {
    ios: 'https://apps.apple.com/us/app/siki-io/id1564875912',
    android: `https://play.google.com/store/apps/details?id=com.siki.app${referrer ? `&referrer=${encodeURIComponent(referrer)}` : ''}`
  };

  return urls[platform] || null;
};

export const setMobileBypass = (bypass = true) => {
  if (bypass) {
    localStorage.setItem('bypassMobileLanding', 'true');
  } else {
    localStorage.removeItem('bypassMobileLanding');
  }
};